module.exports = __webpack_public_path__ + "img/video-bg.adf6513.jpg";